import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../shared.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  project:any;
  userForm: FormGroup;
  updateUserForm: FormGroup;
  updatePasswordForm: FormGroup;
  currentUser:any;
  users = [] as any;
  loading = false;
  error: any;
  editFlag = false;
  passwordFlag = false;

  constructor(
    private formbuilder: FormBuilder,
    private SharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.editFlag = false;
    this.passwordFlag = false;
    this.users = [];

    this.currentUser = this.SharedService.getUser();

    this.project = this.SharedService.getProject();

    this.userForm = this.formbuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      role: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      project: [this.project._id, [Validators.required]]
    })
    this.updateUserForm = this.formbuilder.group({
      _id:[],
      name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      role: ['', [Validators.required]],
      project: [this.project._id, [Validators.required]],
      status: ['active']
    })
    this.updatePasswordForm = this.formbuilder.group({
      _id:[],
      password: ['', [Validators.required, Validators.minLength(8)]]
    })
    this.SharedService.users().subscribe((response) => {
      response.data.forEach(user => {
        if(user.project === this.project._id){
          this.users.push(user)
        }
      });
    },
      (error) => {
        console.log(error);
      })
  }

  edit(user:any){
    console.log(user);
    this.updateUserForm.patchValue(user);
    this.passwordFlag = false;
    this.editFlag = true;
  }

  password(user:any){
    this.updatePasswordForm.patchValue(user);
    this.editFlag = false;
    this.passwordFlag = true;
  }

  cancel(){
    this.editFlag = false;
    this.passwordFlag = false;
  }



  onSubmit(): any {
    if (this.userForm.invalid) {
      this.Toast.fire({
        title: 'Error!',
        text: 'All fields are required',
        icon: 'error'
      })
      return
    } else {
      this.loading = true;
      console.log(this.userForm.value);
      this.SharedService.addUser(this.userForm.value).subscribe((response) => {
        console.log(response);
        this.Toast.fire({
          title: 'Done!',
          text: 'User has been created',
          icon: 'success',
        });
        this.ngOnInit();
        this.loading = false;
      },
        (error) => {
          console.log(error);
          this.error = error.error;
          this.Toast.fire({
            title: 'Error!',
            text: error.error.data,
            icon: 'error',
          });
          this.loading = false;
        })
    }
  }

  onUpdate(): any {
    if (this.updateUserForm.invalid) {
      this.Toast.fire({
        title: 'Error!',
        text: 'All fields are required',
        icon: 'error'
      })
      return
    } else {
      this.loading = true;
      console.log(this.updateUserForm.value);
      this.SharedService.editUser(this.updateUserForm.value._id,this.updateUserForm.value).subscribe((response) => {
        console.log(response);
        this.Toast.fire({
          title: 'Done!',
          text: 'User has been Updated',
          icon: 'success',
        });
        this.ngOnInit();
        this.loading = false;
      },
        (error) => {
          console.log(error);
          this.error = error.error;
          this.Toast.fire({
            title: 'Error!',
            text: error.error,
            icon: 'error',
          });
          this.loading = false;
        })
    }
  }

  onPassword(): any {
    if (this.updatePasswordForm.invalid) {
      this.Toast.fire({
        title: 'Error!',
        text: 'All fields are required',
        icon: 'error'
      })
      return
    } else {
      this.loading = true;
      console.log(this.updatePasswordForm.value);
      this.SharedService.editUser(this.updatePasswordForm.value._id,this.updatePasswordForm.value).subscribe((response) => {
        console.log(response);
        this.Toast.fire({
          title: 'Done!',
          text: 'Password has been Updated',
          icon: 'success',
        });
        this.ngOnInit();
        this.loading = false;
      },
        (error) => {
          console.log(error);
          this.error = error.error;
          this.Toast.fire({
            title: 'Error!',
            text: error.error,
            icon: 'error',
          });
          this.loading = false;
        })
    }
  }

  delete(data: any): any {
    Swal.fire({
      title: 'Are you sure?',
      text: 'To delete ' + data.name,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.SharedService.deleteUser(data._id).subscribe(response => {
          this.Toast.fire({
            title: 'Deleted!',
            text: 'The user has been deleted',
            icon: 'success'
          })
          this.ngOnInit();
        },
        (error)=>{
          console.log(error);
          this.Toast.fire({
            title: 'Error!',
            text: error.error.detail,
            icon: 'error',
          });
        })
      }
    })
  }

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  })

}
